import type { Usage } from '@lyrmo/shared';

/** The share of today's credits already used, from 0 to 1. */
export const usedShare = ({ used, limit }: Usage): number =>
  limit > 0 ? Math.min(used / limit, 1) : 1;

/** How few words are left: none, or at most a tenth of the day's. */
export function usageLevel(usage: Usage): 'empty' | 'low' | undefined {
  if (usage.remaining === 0) return 'empty';
  return usedShare(usage) >= 0.9 ? 'low' : undefined;
}
